export default __webpack_public_path__ + "static/media/Clock Slide In.b823159b.mp3";